import { gql } from '@apollo/client'
import employeeCoreFragment from '../../employee/fragments/employeeCore.fragment'
import employeeDisplayFragment from '../../employee/fragments/employeeDisplay.fragment'
import employeeDisplayShortInfoFragment from '../../employee/fragments/employeeDisplayShortInfo.fragment'
import allowedMonetaryTargetsFragment from './allowedMonetaryTargets.fragment'

export default gql`
  fragment MeetingRest on Meeting {
    other {
      notesEmployee
      notesManager
      agenda
      protocol
    }
    appraisal {
      employeeSelfReflectionPerf
      employeeSelfReflectionPerfScore
      employeeGeneralFeedback
      reviewerGeneralFeedback
      meetingGeneralFeedback
      targetCommentsShared
      evaluationShared
      selfReflectionShared
      shareWithHR
      feedbackForHR
    }
    employeePrepared
    employeePreparationDate
    managerPrepared
    meetingSteps {
      id
      viewId
      status
      position
      type
    }
    managerPreparationActiveStep {
      id
      viewId
      type
    }
    employeePreparationActiveStep {
      id
      viewId
      type
    }
    activeMeetingStep {
      id
      viewId
      type
    }
    employee {
      ...EmployeeDisplay
      replyEntryDate
      email
      skillCenterUrl
      careerPathEvaluation {
        salaryEvaluation
        bonusEvaluation
        summary
        salary
        targetBonus
      }
      currentContract {
        legalEntity {
          country
        }
        currencyForPayments
      }
      branchOffice {
        timezone
      }
    }
    reviewer {
      ...EmployeeDisplayShortInfo
    }
    objectivePayment {
      id
      paymentDate
      paymentDateValid
      deduction
      deductionReason
    }
    hasEvaluationScore
    conclusionPdfFileName
    conclusionPdfDownloadToken
    nextPaymentCycle
    requiresSpecialHandlingOfLowTag
    ...AllowedMonetaryTargets
  }
  ${employeeCoreFragment}
  ${employeeDisplayFragment}
  ${employeeDisplayShortInfoFragment}
  ${allowedMonetaryTargetsFragment}
`
